export function handleEnterKey(e: React.KeyboardEvent, handler: (e: React.KeyboardEvent) => void) {
	if (e.key === "Enter") {
		e.preventDefault();
		handler(e);
	}
}

export function handleSpaceKey(e: React.KeyboardEvent, handler: (e: React.KeyboardEvent) => void) {
	if (e.key === " ") {
		e.preventDefault();
		handler(e);
	}
}

export function handleEnterSpaceKey(
	e: React.KeyboardEvent,
	handler: (e: React.KeyboardEvent) => void
) {
	if (["Enter", " "].includes(e.key)) {
		e.preventDefault();
		handler(e);
	}
}
